import { Grid } from 'jrgrid';
import { pageRequestedItems } from '../api';
import Navbar from '../../../components/Navbar';
import { requestedItemColumns, filterButtonsReqItem } from '../utils';
import { Button, Row, Col } from 'react-bootstrap';
import React, { Fragment } from 'react';
import { Loader } from '../../../components/Loader';
import { useSelector } from 'react-redux';

export const NonBarcodedPage = (props: any) => {
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));

  const [gridFilter, setGridFilter] = React.useState([
    {
      id: 'needsBarcode',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: '0',
    },
    {
      id: 'department',
      type: 'string',
      operand: 'and',
      isLike: false,
      value: user.currentRole.departmentAbbreviation,
    },
  ]);

  const renderGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid..' />;
    } else {
      let filter = [];

      return (
        <Grid
          amount={20}
          columns={requestedItemColumns}
          query={pageRequestedItems}
          queryName='pageRequestedItems'
          defaultSortField='requestedItemId'
          globalFilters={gridFilter ? [...gridFilter, ...filter] : [...filter]}
          queryTag='requestedItemsPage'
        />
      );
    }
  };

  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={8}>
            {/* {filterButtonsReqItem.map((item, index) => {
              return (
                <Button
                  key={index}
                  className='mt-3 mb-3 ml-2'
                  onClick={() => {
                    setGridFilter(item.filter);
                  }}>
                  {item.title}
                </Button>
              );
            })} */}
          </Col>
          <Col md={4}>
            <h3 className='mt-3 mb-3 ml-2 mr-2 float-right'>Non-Barcoded</h3>
          </Col>
        </Row>
        <div className='ml-2 mr-2'>{renderGrid()}</div>
      </div>
    </Fragment>
  );
};
